<template>
<div>
  <div class="view-title">
    <div class="back-button">
      <div>
        <img
          src="../assets/backarrow.svg"
          alt="back"
          height="30px"
          v-touch:tap="backToSettings"/>
        <p>{{ $t('commons.back') }}</p>
      </div>
    </div>
  </div>
  <div class="view-content">
    <h2>{{ $t('about.about_my_datas_title') }}</h2>
    <p>{{ $t('about.content') }}</p>
  </div>
</div>
</template>


<script>
export default {
  methods: {
    backToSettings() {
      this.$router.push('settings');
    },
  },
};
</script>


<style scoped>
  .view-title {
    display: grid;
    grid-template-columns: 2fr 8fr 2fr;
    background-color: cornflowerblue;
    position: fixed;
    top: 0;
    width: 100%;
    height: 60px;
  }

  .back-button {
    margin-top: 1vh;
    margin-bottom: 1vh;
  }

  .back-button > div > p {
    margin: 0;
    font-size: 12px;
    color: #ffffff;
    margin-top: -6px;
  }

  .view-content {
    margin-top: 80px;
    margin-left: 24px;
    margin-right: 24px;
  }

</style>
